import React, { useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';
import AboutUs from './pages/AboutIUs/AboutUs';
import AboutEvent from './pages/AboutEvent/AboutEvent';
import ApplyForStall from "./pages/ApplyForStall/ApplyForStall";
import ApplyStallList from './pages/ApplyForStall/ApplyStallList';
import BookingPage from './pages/BookingPage/BookingPage';
import Login from './pages/Login';
import QRScanner from './pages/QRScanner';
import SponsorsList from './pages/SponsorWithUs/SponsorsList';
import SponsorWithUs from "./pages/SponsorWithUs/SponsorWithUs";
import SummaryReport from './pages/SummaryReport/SummaryReport';
import { useSelector } from 'react-redux';
import EventList from './pages/AboutEvent/EventList';
import PromoCode from './pages/PromoCode/PromoCode';
import TicketRateList from './pages/TicketRate/TicketRateList';
import Users from './pages/Users/Users';
import UserForm from './pages/Users/UserForm';
import { hasScreenAccess } from './utils/screenAccess';

const ProtectedRoute = ({ isAuthenticated, screenRights, screenUrl, children }) => {
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    if (!hasScreenAccess(screenRights, screenUrl)) {
        return <Navigate to="/" replace />;
    }
    return children;
};

function App() {
    const [open, setOpen] = useState(false);

    const isAuthenticated = useSelector(state => state.reduxMaster.isAuthenticated);
    const screenRights = useSelector(state => state.reduxMaster.screenRights);

    return (
        <Router>
            <Header setOpen={setOpen} />
            <Login open={open} setOpen={setOpen} />

            <Routes>
                <React.Fragment>
                    <Route path="/" element={<BookingPage />} />

                    <Route path="/sponsor-with-us" element={<SponsorWithUs />} />
                    <Route path="/book-for-stall" element={<ApplyForStall />} />
                    <Route path="/about-us" element={<AboutUs />} />

                    {/* Protected Route */}
                    <Route path="/admin-home" element={<ProtectedRoute isAuthenticated={isAuthenticated}></ProtectedRoute>} />
                    <Route path="/event-list" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/event-list"><EventList /></ProtectedRoute>} />
                    <Route path="/event-promocode" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/event-promocode"><PromoCode /></ProtectedRoute>} />
                    <Route path="/event-ticketrate" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/event-ticketrate"><TicketRateList /></ProtectedRoute>} />
                    <Route path="/about-event" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/about-event"><AboutEvent /></ProtectedRoute>} />
                    <Route path="/qr-scanner" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/qr-scanner"> <QRScanner /></ProtectedRoute>} />
                    <Route path="/summary-report" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/summary-report"> <SummaryReport /></ProtectedRoute>} />
                    <Route path="/sponsors-list" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/sponsors-list"> <SponsorsList /></ProtectedRoute>} />
                    <Route path="/apply-stall-list" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/apply-stall-list"> <ApplyStallList /></ProtectedRoute>} />

                    <Route path="/user-list" element={<ProtectedRoute isAuthenticated={isAuthenticated} screenRights={screenRights} screenUrl="/user-list"> <Users /></ProtectedRoute>} />
                    <Route path="/user-form" element={<ProtectedRoute isAuthenticated={isAuthenticated}> <UserForm /></ProtectedRoute>} />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />

                </React.Fragment>
            </Routes>

            <Footer />
        </Router>
    );
}

export default App;
